import { ACTIONS } from './actions';
import { UnknownObject } from '@monofront/types';

export type RegisterMachineContext = {
  currentStepIndex?: number;
  registerStepIndex?: number;
  isAuthenticated?: boolean;
};

export type RegisterMachineEvents =
  | { type: ACTIONS.PREVIOUS }
  | { type: ACTIONS.NEXT }
  | { type: ACTIONS.FINISH_FORM }
  | { type: ACTIONS.EXIT_FORM }
  | {
      type: ACTIONS.AUTH_CHANGED;
      payload: { isAuthenticated: boolean };
    };

export type RegisterMachineInputs = { isAuthenticated: boolean };

export enum REGISTER_STEPS_TYPES {
  REGISTER = 'RegisterStep',
  SUBSCRIPTION_SUMMARY = 'SubscriptionSummaryStep',
  SUBSCRIPTION_PAYMENT = 'SubscriptionPaymentStep',
  CONTENT = 'ContentStep',
}

export type Step = {
  uid: string;
  type: REGISTER_STEPS_TYPES;
  stepName: string;
  data: UnknownObject;
  trackingData?: {
    page_path?: string;
  };
  [key: string]: unknown;
};
